// eslint-disable-next-line
export const JWTTokenMiddleware = store => next => action => {
	const token = action.payload?.data?.data?.token
	if (token) {
		localStorage.setItem('token', token)
	}
	next(action)
}
